<template>
  <div class="form-checkbox-list">
    <label :for="`${prefix}-all`">
      <input type="checkbox" :id="`${prefix}-all`" value="All" v-model="all" />
      <span>All</span>
    </label>

    <div class="form-checkbox-list__checkboxes">
      <label :for="`${prefix}-${item.value}`" v-for="item in checkboxes" :key="item.value">
        <input type="checkbox" :id="`${prefix}-${item.value}`" :value="item.value" v-model="model">
        <span>{{ item.label }}</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElementFormCheckboxList',
  props: {
    prefix: {
      type: String,
      required: true
    },
    checkboxes: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      all: false,
      model: []
    }
  },
  watch: {
    all () {
      this.checkAll(this.all)
    },
    model () {
      if (this.model.length === this.checkboxes.length) this.all = true
      this.$emit('change', this.model)
    }
  },
  methods: {
    checkAll (status) {
      this.model = []
      if (status) {
        this.checkboxes.forEach(checkbox => {
          this.model.push(checkbox.value)
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .form-checkbox-list{
    margin-bottom: 1.5rem;
    padding: 1rem;
    background-color: colors("foreground");
    border: 1px solid colors("border");
    border-radius: 5px;

    label{
      span{
        cursor: pointer;
        margin-left: 1rem;
      }
    }

    // Checkboxes

    &__checkboxes{
      margin-top: 1rem;
      max-height: 10rem;
      overflow: auto;
    }
  }
</style>
